module.exports = __webpack_public_path__ + "img/knot_til_not.072c1a42.png";